import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

const VARIANT_CONFIG = {
  green: theme => ({
    background: theme.palette.brand.green[500],
    logo: theme.palette.brand.green[300],
  }),
  blue: theme => ({
    background: theme.palette.brand.blue[400],
    logo: theme.palette.brand.blue[300],
  }),
  orange: theme => ({
    background: theme.palette.brand.yellow[400],
    logo: theme.palette.brand.yellow[300],
  }),
  red: theme => ({
    background: theme.palette.brand.red[600],
    logo: theme.palette.brand.red[400],
  }),
  // Official logo colors (not a category swatch) — dark background, white mark.
  brand: theme => ({
    background: theme.palette.brand.green[700],
    logo: theme.palette.common.white,
  }),
  // Same official colors, roles swapped — for use on dark surfaces.
  brandInverted: theme => ({
    background: theme.palette.common.white,
    logo: theme.palette.brand.green[700],
  }),
};

const useStyles = Mui.makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: props => VARIANT_CONFIG[props.variant](theme).background,
  },
}));

function EskolareBadge(props) {
  const { variant, size } = props;

  // Hooks
  const theme = Mui.useTheme();
  const classes = useStyles({ variant });

  // Constants
  const logoColor = VARIANT_CONFIG[variant](theme).logo;

  return (
    <Mui.Box className={classes.root} style={{ width: size, height: size }}>
      <svg
        width="75%"
        height="75%"
        viewBox="4 9 24 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.063 21.5C20.5307 21.5 20.0181 21.4318 19.5527 21.2899C18.5438 20.9823 17.652 20.3768 16.9377 19.534C15.499 20.6848 13.9578 21.3259 12.5617 21.3259C11.3004 21.3259 10.194 20.789 9.36542 19.793C8.02589 20.781 6.61856 21.3259 5.33594 21.3259V19.7081C6.39049 19.7081 7.50865 19.1842 8.52094 18.4029C7.59026 16.2712 7.67144 13.4151 8.75696 11.8186C9.40601 10.8666 10.3547 10.4058 11.4306 10.5263L11.4649 10.5314C12.9296 10.7561 13.7334 11.7977 13.6163 13.3192C13.5008 14.8425 12.4479 16.8131 10.8694 18.4619C10.7782 18.5564 10.687 18.6489 10.5962 18.7385C11.0276 19.2624 11.662 19.7068 12.5638 19.7068C13.6347 19.7068 14.865 19.1582 16.0497 18.1723C16.0024 18.0765 15.9551 17.9802 15.9116 17.8827C15.2525 16.4147 15.0424 14.6948 15.3454 13.2786C15.7513 11.3742 17.0239 10.3163 18.6677 10.5263L18.7049 10.533C20.1616 10.7887 20.9525 11.8579 20.819 13.3941C20.6889 14.9011 19.6569 16.8281 18.1241 18.4405C18.6141 19.036 19.2452 19.5064 20.0231 19.7441C21.7154 20.2584 24.4267 19.3729 25.1821 17.6073L26.6697 18.2422C25.7763 20.3333 23.2537 21.5 21.0634 21.5H21.063ZM11.0937 12.1245C10.8058 12.1245 10.4363 12.2254 10.0944 12.7284C9.39932 13.7519 9.30851 15.6723 9.80482 17.2265C11.0368 15.8987 11.9189 14.3135 12.0035 13.197C12.0621 12.4287 11.7089 12.2028 11.2356 12.1329C11.1916 12.1262 11.1427 12.1249 11.0925 12.1249H11.0941L11.0937 12.1245ZM18.2785 12.1195C17.4307 12.1195 17.0741 12.92 16.926 13.6184C16.7193 14.5818 16.7469 16.0904 17.193 17.2249C18.2768 15.9765 19.1196 14.2775 19.2092 13.2523C19.2594 12.6714 19.0384 12.2237 18.4459 12.1295C18.389 12.1228 18.3321 12.1199 18.2781 12.1199L18.2785 12.1195Z"
          fill={logoColor}
        />
      </svg>
    </Mui.Box>
  );
}

EskolareBadge.propTypes = {
  variant: PropTypes.oneOf(['blue', 'green', 'orange', 'red', 'brand', 'brandInverted']).isRequired,
  size: PropTypes.number,
};

EskolareBadge.defaultProps = {
  size: 32,
};

export default EskolareBadge;
